import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDrivers } from "./../../constants";
import { DriverContactsResponseData } from "./getDriverContacts.types";

export const requestGetDriverContacts = async (
  driverId: string
): Promise<DriverContactsResponseData> => {
  return await instance.get(
    buildUrl(
      ApiRoutesDrivers.Drivers,
      driverId,
      ApiRoutesDrivers.DriverContacts
    )
  );
};
